import React from "react";
import PageLayout from "../components/PageLayout";

export default function About() {
    return (
        <PageLayout
            title="About Us"
            subtitle="Learn more about Pharmacy Wiki and our mission"
            pageTitle="About Us"
            showSearch={false}
            showGradient={true}
        >
            <div className="flex flex-col gap-3 mt-8 text-secondary/80 text-14">
                <div>
                    Welcome to Pharmacy.Wiki—your free, independent resource for exploring the world of generic medicines. Our mission is to empower you with accurate, unbiased information about high-quality, safe, and effective generics from India and around the globe.
                </div>
                <div className="font-semibold text-16 text-secondary">
                    Our Vision
                </div>
                <div>
                    In many parts of the world, pharmaceutical laws are outdated and heavily influenced by big pharma, corporate interests, and political greed. These forces often drive policies that limit access to affordable medications, promote brand-name products, and stifle competition—even when equivalent or superior generics are available. At Pharmacy.Wiki, we believe that everyone deserves access to reliable information that empowers them to make informed choices about their healthcare. We are here to shine a light on safe and effective generic alternatives that are often as good as, if not better than, their brand-name counterparts.
                </div>
                <div className="font-semibold text-16 text-secondary">
                    What We Do
                </div>
                <div>
                    Pharmacy.Wiki is dedicated to providing comprehensive, well-researched content on generic medicines, including:
                </div>
                <div>
                    <ul className="ml-5 list-disc">
                        <li>
                            Detailed Comparisons: We break down the similarities between well-known brand names (like Cialis) and their chemical equivalents (like tadalafil), highlighting the many manufacturers producing these generics.
                        </li>
                        <li>
                            Up-to-Date Information: Our content is regularly updated to reflect the latest research, regulatory changes, and industry trends.
                        </li>
                        <li>
                            Educational Resources: We offer guides, reviews, and insights that help you navigate the complex world of pharmaceuticals, ensuring you are well-informed before making any health-related decisions.
                        </li>
                    </ul>
                </div>
                <div>
                    <span className="font-semibold text-secondary">Please note:</span> Our content is for informational purposes only. We do not sell or distribute medications, nor do we offer medical advice. Always consult with a qualified healthcare professional before making any decisions regarding your health or medication.
                </div>
                <div className="font-semibold text-16 text-secondary">
                    How We're Funded
                </div>
                <div>
                    Pharmacy.Wiki is a free resource that is made possible through the support of our readers and sponsors. We do not charge for access to our content, and we remain committed to keeping our site free of paywalls and subscription fees. Our funding comes from:
                </div>
                <div>
                    <ul className="ml-5 list-disc">
                        <li>
                            Donations: We gratefully accept voluntary donations from our readers. These contributions help us cover hosting, development, and research costs.
                        </li>
                        <li>
                            Sponsorship: We work with sponsors who share our commitment to transparency and accessible healthcare information. Sponsorships are clearly marked on our site and do not influence our editorial content.
                        </li>
                        <li>
                            Advertising: When appropriate, we may display unobtrusive advertisements from trusted partners that are aligned with our mission. Our advertising policies ensure that these ads do not compromise the integrity or independence of our content.
                        </li>
                    </ul>
                </div>
                <div className="pt-4 font-semibold text-16 text-secondary">
                    Get Involved
                </div>
                <div className="font-semibold text-16 text-secondary">
                    List Your Company or Drugs on Our Site
                </div>
                <div>
                    If you represent a company or have products you'd like to feature on Pharmacy.Wiki, we welcome collaboration. We offer a platform for companies to list their generic drugs, share detailed product information, and reach a wide audience interested in safe, effective, and affordable medications. To inquire about placement or sponsorship opportunities, please contact us at support@pharmacy.wiki. We review all submissions carefully to ensure they align with our commitment to providing accurate, unbiased information.
                </div>
                <div className="font-semibold text-16 text-secondary">
                    Join the Conversation
                </div>
                <div>
                    We believe in the power of community. Whether you're a healthcare professional, a researcher, or simply someone passionate about accessible healthcare, we invite you to explore our content, share your insights, and join the conversation on social media and in our comments sections.
                </div>
                <div className="font-semibold text-16 text-secondary">
                    Our Commitment
                </div>
                <div>
                    At Pharmacy.Wiki, our commitment is to transparency, accuracy, and independence. We strive to provide you with the best possible information, free from the influence of corporate or political pressures. Our goal is to help you understand that there are effective, safe, and often more affordable generic alternatives available—giving you the power to make informed choices about your health.
                </div>
                <div>
                    Thank you for visiting Pharmacy.Wiki. Together, we can advocate for a more transparent and equitable healthcare system.
                </div>
                <hr className="my-4 border-t border-gray-300" />
                <div className="italic">
                    Our content is for informational purposes only. Always consult a healthcare professional before making any health or medication-related decisions.
                </div>
            </div>
        </PageLayout>
    );
}